import React from "react";
import clsx from "clsx";
import { useFormContext } from "react-hook-form";

import { HookFormInputGroup } from "components";
import { ExampleCalculationValue } from "globalConstants";
import { floatWithComma2Normalizer } from "validators";
import { maxValue100, onlyPercent, required } from "validators/validation";

import { WaterfallExampleMessage } from "./waterfallExampleMessage";

import styles from "./../splitProfile.module.scss";

type TotalRevenueShareFieldProps = {
	isLoading: boolean;
	isWaterfall: boolean;
};

export const TotalRevenueShareField = ({
	isLoading,
	isWaterfall,
}: TotalRevenueShareFieldProps) => {
	const {
		register,
		formState: { errors },
	} = useFormContext();

	const exampleValue = floatWithComma2Normalizer(ExampleCalculationValue);

	return (
		<HookFormInputGroup
			register={register}
			name="totalRevenueShare"
			label="Total Revenue Share, %"
			placeholder="0"
			colLabel={6}
			colInput={6}
			validator={{
				required,
				maxValue100,
			}}
			normalize={onlyPercent}
			errors={errors}
			blurLoading={isLoading}
			showRequiredMark
			addon={isWaterfall ? exampleValue : ""}
			external={
				isWaterfall && <WaterfallExampleMessage value={exampleValue} />
			}
			className={clsx(styles.innerContentInputGroup)}
		/>
	);
};
